import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import { updatePageColors } from './helpers/Helpers.js';
import reportWebVitals from './reportWebVitals';

// Set initial colors based on current path (before React renders)
const initialPath = window.location.pathname;
updatePageColors(initialPath);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
